import { getGetFirstGenericEmbeddingModelMapperById } from 'features/embeddingModels/store/selectors';
import { useAppSelector } from 'store/hooks';

export const useGetEmotionalityMapperName = (embeddingModelId: string) => {
  const mapper = useAppSelector(getGetFirstGenericEmbeddingModelMapperById)(embeddingModelId);

  return mapper?.name ?? 'de_emotions_standard';
};
